import type { CountryForSelect } from '../../models/country';

const sortCountriesByLabel = (countries: CountryForSelect[]) =>
  countries.sort((a, b) => a.label.localeCompare(b.label));

export { sortCountriesByLabel };
